import { GET_ELECTRICIAN, REQUEST_ELECTRICIAN } from '../actions/Types'

const getElectrician = (state={loading: false, data: []}, action) => {
    if (action.type === GET_ELECTRICIAN){
        return {loading: false, data: action.payload}
    }
    else if (action.type === REQUEST_ELECTRICIAN){
        return {
            loading: true,
            data: []
        }
    }
    return state
}

export default getElectrician